export default "__VITE_ASSET__CKxoDOcT__"